export const setFormData = <TData>(data: TData) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data!)) {
    if (typeof value === "undefined") continue
    if (typeof value == "boolean") formData.append(key, value ? "1" : "0")
    else if (Array.isArray(value)) {
      value.map((v) => formData.append(key + "[]", v))
    } else formData.append(key, (value as any) || "")
  }
  return formData
}
